import { render, staticRenderFns } from "./ItemsPopUp.vue?vue&type=template&id=7bf95939&scoped=true"
import script from "./ItemsPopUp.vue?vue&type=script&lang=js"
export * from "./ItemsPopUp.vue?vue&type=script&lang=js"
import style0 from "./ItemsPopUp.vue?vue&type=style&index=0&id=7bf95939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf95939",
  null
  
)

export default component.exports